import { render, staticRenderFns } from "./HomeCardLink.vue?vue&type=template&id=72e4762e&scoped=true&"
import script from "./HomeCardLink.vue?vue&type=script&lang=js&"
export * from "./HomeCardLink.vue?vue&type=script&lang=js&"
import style0 from "./HomeCardLink.vue?vue&type=style&index=0&id=72e4762e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4762e",
  null
  
)

export default component.exports